<template>

  <div class="sld_address_list">
  <MemberTitle memberTitle="Address Management"></MemberTitle>
         <p>Address Management</p>
    <div class="selegg">
      <div
        class="selegg_on"
        :class="{ selegg_xz: tabIndex == 1 }"
        @click="changeTab(1)"
      >
        Domestic Warehouse
      </div>
      <div
        class="selegg_on"
        :class="{ selegg_xz: tabIndex == 2 }"
        @click="changeTab(2)"
      >
        Overseas Warehouse
      </div>
      <div  class="selegg_on" :class="{ selegg_xz: tabIndex == 3 }" @click="changeTab(3)" > Shipping Port
</div>
    </div>
    <div class="tablexx" v-if="tabIndex == 1 || tabIndex == 2">
      <div class="tablexx_nr">
        <div class="tablexx_sr">
          <span>Recipient</span>
          <el-input v-model="sjman" placeholder="Please enter contact"></el-input>
          <span class="phone">Phone</span>
          <el-input v-model="phone" placeholder="Please enter phone"></el-input>
        </div>
        <div class="tablexx_button">
          <div class="sousuo" @click="searches">Search</div>
          <div class="czu" @click="reset">Reset</div>
        </div>
      </div>
      <div class="adsele">
        <!-- 国内仓库弹窗 -->
        <div type="text" class="addcit" @click="addAddress" >Add New Address</div>

        <!-- 海外仓库弹窗 -->

        <div class="detil" @click="detall_1">Batch Delete</div>
      </div>
      <div class="teblek">
        <el-table ref="multipleTable"  :data="tableData" tooltip-effect="dark"    style="width: 100%"  @selection-change="handleSelectionChange"  >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="Recipient" width="120">
            <template #default="scope">{{ scope.row.memberName }}</template>
          </el-table-column> 
          <el-table-column prop="name" label="Detailed Address" width="120" v-if="addressType=='1'||addressType==1">
   
            <template #default="scope"  >
              <span v-if="addressType=='1'||addressType==1">{{scope.row.addressAll}}{{ scope.row.detailAddress }}</span>
             </template>
          </el-table-column>
          <el-table-column prop="name" label="Detailed Address" width="120" v-if="addressType=='2'||addressType==2">
            <template #default="scope"  >
             <span v-if="addressType=='2'||addressType==2"></span> {{scope.row.countryName}}{{ scope.row.detailAddress }}
             </template>
          </el-table-column>
          <el-table-column prop="address" label="Zip Code" width="120" show-overflow-tooltip>
            <template #default="scope">{{ scope.row.zipCode }}</template>
          </el-table-column>
          <el-table-column prop="address" label="Email"  width="120" show-overflow-tooltip>
            <template #default="scope">{{ scope.row.email }}</template>
          </el-table-column>
          <el-table-column prop="address" label="Phone" width="120" show-overflow-tooltip>
            <template #default="scope">{{ scope.row.telMobile }}</template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="Set as Default"
            show-overflow-tooltip
          >
            <template #default="scope">
              <el-switch
                v-model="scope.row.isDefault"
                active-color="#409eff"
                inactive-color="#f4f4f4"
                @change="enddes(scope.row.isDefault, scope.row.addressId)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="Action" align="center">
            <template #default="scope">
              <el-button size="mini" @click="handleEdit(scope.row)"
                >Edit</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >Delete</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="fytou">
        <el-pagination
          @prev-click="handlePrevCilickChange1"
          @next-click="handleNextCilickChange2"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="searchParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination"
        ></el-pagination>
      </div>
    </div>
    <div class="tablexx" v-if="tabIndex == 3">
      <div class="tablexx_nr">
        <div class="tablexx_sr">
          <span>Shipping Port</span>
          <el-input v-model="srgkk" placeholder="Please enter port"></el-input>
        </div>
        <div class="tablexx_button">
          <div class="sousuo" @click="sousuo1">Search</div>
          <div class="czu" @click="czu1">Reset</div>
        </div>
      </div>
      <div class="adsele">
        <div @click="addnewgk">Add New Port</div>
        <div class="detil" @click="detall_2">Batch Delete</div>
      </div>
      <div class="teblek">
        <el-table
          ref="multipleTable"
          :data="gklist"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange1"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="Shipping Port" width="150">
            <template #default="scope">{{ scope.row.portName }}</template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="Set as Default"
            show-overflow-tooltip
            width="120"
          >
            <template #default="scope">
              <el-switch
                v-model="scope.row.isDefault"
            
                active-color="#409eff"
                inactive-color="#f4f4f4"
                @change="enddes1(scope.row.isDefault, scope.row.portId)"
              ></el-switch>
            
            </template>
          </el-table-column>
         
          <el-table-column prop="address" label="Action" show-overflow-tooltip>
            <template #default="scope">
              <el-button
                size="mini"
                @click="handleEdit1(scope.row)"
                >Edit</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDeleteel(scope.$index, scope.row)"
                >Delete</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="fytou">
        <el-pagination
          @prev-click="handlePrevCilickChanges"
          @next-click="handleNextCilickChanges"
          @size-change="handleSizeChanges"
          @current-change="handleCurrentChanges"
          :current-page="gangkouue.current"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="gangkouue.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="gknum"
        ></el-pagination>
      </div>
    </div>
    </div>
  <SldAddressOperation
    v-if="addressVisibleFlag"
    @close="close"
    @refreshAddress="refreshAddress"
    :visibleFlag="true"
    :type="type"    
    :addressInfo="addressInfo"
    :areaData="options"
    :addressType="addressType"
  />
  <addgk
    v-if="addressVisibleFlag1"
    @close1="close1"
    @refreshAddress1="refreshAddress1"
    :visibleFlag="true"
    :type1="type1"    
    :addressInfo="addressInfo1"
    :areaData="options"
    :addressType="addressType"
  />
</template>
<script>
import MemberTitle from "@/components/MemberTitle";
import { getCurrentInstance, onMounted, ref, reactive } from "vue";
import SldAddressOperation from "../../components/AddressOperation";
import addgk from "../../components/addgk";
export default {
  components: {
    SldAddressOperation,
    addgk,
    MemberTitle
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const addressVisibleFlag = ref(false);
    const addressVisibleFlag1 = ref(false);
    const type = ref("add");
    const type1 = ref("add");
    const pagination = ref("");
    const srgkk = ref("");
    const tabIndex = ref(1);
    const sjman = ref("");
    const phone = ref("");
    const tableData = ref([]);
    const addressIds = ref([]);
    const addressType = ref("1");
    const Delete = ref([]);
    const Delete1 = ref([]);
    const portIds = ref([]);
    const addressInfo = reactive({ data: {} });
    const addressInfo1 = ref({ data: {} });
    const portes = ref("");
    const options = ref([]);
    const cascaderProps = { label: "regionName", value: "regionCode" };
    const value1 = ref(false);
    const cangcat = ref([]);
    const enddcs = ref({
      addressId: "",
      isDefault: "",
    });
    const hhh = ref("1111");
    const gknum = ref(0);
    const shdz = reactive({});
    const dialogFormVisible = ref(false);
    const dialogFormVisible1 = ref(false);
    const gklist = ref({});
    const searchParams = reactive({
      addressType: 1,
      current: 1,
      memberName: "",
      pageSize: 5,
      telMobile: "",
    });
    const gangkouue = reactive({
      current: 1,
      pageSize: 5,
      portName: "",
    });
    //地址按钮切换
    const changeTab = (index) => {
      tabIndex.value = index;
      console.log(tabIndex.value);
      if (tabIndex.value == 1 || tabIndex.value == 2) {
        gnc();
      } else if (tabIndex.value == 3) {
        console.log(3333333);
        gkue()
      }
    };
    //批量删除的id
    const handleSelectionChange = (val) => {
      Delete.value = val;
      console.log(Delete.value);
    };
    //批量删除的id
    const handleSelectionChange1 = (val) => {
      Delete1.value = val;
       
    };
    //国内和海外仓请求接口
    const gnc = () => {
      if (tabIndex.value == 1) {
        addressType.value = "1";
        searchParams.addressType = 1;
      } else if (tabIndex.value == 2) {
        searchParams.addressType = 2;
        addressType.value = "2";
      }
      proxy
        .$get("/v3/member/front/memberAddress/list", searchParams)
        .then((res) => {
          tableData.value = res.data.list;
          pagination.value = res.data.pagination.total;
        });
    };

    //当前页
    const handleCurrentChange = (e) => {
      console.log(e);
      searchParams.current = e;
      gnc();
    };
    const handleSizeChange = (e) => {
      console.log(e);
      searchParams.pageSize = e;
      gnc();
    };
    const handlePrevCilickChange1 = (e) => {
      console.log(e);
      searchParams.current = e;
      gnc();
    };
    const handleNextCilickChange2 = (e) => {
      console.log(e);
      searchParams.current = e;
      gnc();
    };
    const handleCurrentChanges = (e) => {
      console.log(e);
      gangkouue.current = e;
      gkue();
    };
    const handleSizeChanges = (e) => {
      console.log(e);
      gangkouue.pageSize = e;
      gkue();
    };
    const handlePrevCilickChanges = (e) => {
      console.log(e);
      gangkouue.current = e;
      gkue();
    };
    const handleNextCilickChanges = (e) => {
      console.log(e);
      gangkouue.current = e;
      gkue();
    };
    //设置默认
    const enddes = (isDefault, addressId) => {
      enddcs.value.addressId = addressId;
      // enddcs.value.isDefault = isDefault;
      if (isDefault == true) {
        enddcs.value.isDefault = 1;
      } else {
        enddcs.value.isDefault = 0;
      }
      proxy
        .$post(
          "/v3/member/front/memberAddress/changeDefaultAddress",
          enddcs.value
        )
        .then((res) => {
          if (res.state == 200) {
            //设置默认地址选中一个其他全部取消portId
            gnc();
          }
        });
    };
     const enddes1 = (isDefault, portId) => {
       console.log(11111)
      enddcs.value.portId = portId;
      // enddcs.value.isDefault = isDefault;
      if (isDefault == true) {
        enddcs.value.isDefault = 1;
      } else {
        enddcs.value.isDefault = 0;
      }
      proxy
        .$post(
          "/v3/member/front/memberDeliverPort/changeDefault",
          enddcs.value
        )
        .then((res) => {
          if (res.state == 200) {
            //设置默认地址选中一个其他全部取消
            gkue();
          }
        });
    };
    //删除收获地址
    const handleDelete = (index, row) => {
      addressIds.value.push(row.addressId);

      proxy
        .$post("/v3/member/front/memberAddress/del", {
          addressIds: addressIds.value.join(","),
        })
        .then((res) => {
          console.log(res);
          gnc();
        });
    };
    const handleDeleteel = (index, row) => {
      portIds.value.push(row.portId);
      proxy
        .$post("/v3/member/front/memberDeliverPort/del", {
          portIds: portIds.value.join(","),
        })
        .then((res) => {
          console.log(res);
          gkue();
        });
    };
    //地址弹框切换
    const addAddress = () => {
      type.value = "add";
      addressVisibleFlag.value = true;
    };
    const addnewgk=()=>{
      type1.value = "add";
      addressVisibleFlag1.value = true;
    }
    const close = () => {
        addressVisibleFlag.value = false;
    };
        const close1 = () => {
        addressVisibleFlag1.value = false;
    };
    
    //获取地址
    const citey = () => {
      proxy.$get("/v3/system/front/region/getList").then((res) => {
        options.value = res.data[0];
        console.log(options.value);
      });
    };
    const handleChange = (cangcat) => {
      console.log(cangcat);
    };
    //添加新地址

    //发货港口接口请求
    const gkue = () => {
      console.log(11111)
      proxy
        .$get("/v3/member/front/memberDeliverPort/list", gangkouue)
        .then((res) => {
          // tableData.value = res.data.list;
          // console.log(tableData);
          console.log(res);
          gklist.value = res.data.list;
          // console.log(gklist.value)
         gklist.value.map(item=>{
             if(item.isDefault==1){
                item.isDefault=true
             }else{
               item.isDefault=false
             }
         }) 
          console.log( gklist.value)
          gknum.value = res.data.pagination.total;
          console.log(1111, gklist);
        });
    };
    const sousuo1 = () => {
      gangkouue.portName = srgkk.value;
      gkue();
      srgkk.value = "";
    };
    const czu1 = () => {
      gangkouue.portName = "";
      gangkouue.current = 1;
      gkue();
    };
    //搜索
    const searches = () => {
      searchParams.memberName = sjman.value;
      searchParams.telMobile = phone.value;
      gnc();
      sjman.value = "";
      phone.value = "";
    };
    //批量删除
    const detall_1 = () => {
      let arr = [];
      Delete.value.map((item) => {
        arr.push(item.addressId);
      });
      let addressIds1 = arr.toString();
      proxy
        .$post("/v3/member/front/memberAddress/del", {
          addressIds: addressIds1,
        })
        .then((res) => {
          console.log(res);
          gnc();
        });
    };
    //批量删除
     const detall_2 = () => {
      let arr = [];
      console.log(Delete1.value)
      Delete1.value.map((item) => {
        arr.push(item.portId);
      });
      console.log(arr)
      let addressIds1 = arr.toString();
      proxy
        .$post("/v3/member/front/memberDeliverPort/del", {
          portIds: addressIds1,
        })
        .then((res) => {
          console.log(res);
           gkue()
        });
    };
    //重置
    const reset = () => {
      searchParams.memberName = sjman.value;
      searchParams.telMobile = phone.value;
      gnc();
    };
    const handleEdit = (scope) => {
      console.log(scope)
      type.value = "edit";
      addressVisibleFlag.value = true;
      addressInfo.data = scope;

    };
     const handleEdit1 = (scope) => {
      type1.value = "edit";
      addressVisibleFlag1.value = true;
      addressInfo1.value.data = scope;
    };
    const refreshAddress = () => {
      gnc();
    };
    const refreshAddress1 = () => {
        gkue();
     
    };
    onMounted(() => {
      gkue();
      gnc();
      citey();
    });
    return {
      changeTab,
      tabIndex,
      sjman,
      phone,
      gnc,
      handleSelectionChange,
      handleSelectionChange1,
      detall_1,
      type1,
      addressInfo1,
      tableData,
      addressInfo,
      value1,
      handleEdit,
        handleEdit1,
        Delete1,
      searches,
      Delete,
      reset,
      portes,
      gkue,
      enddes,
      enddes1,
      enddcs,
      handleDelete,
      dialogFormVisible,
      shdz,
      hhh,
      dialogFormVisible1,
      citey,
      cangcat,
      handleChange,
      options,
      cascaderProps,
      addAddress,
      addressVisibleFlag,
      close,
      addressType,
      type,
      pagination,
      searchParams,
      handleCurrentChange,
      handleSizeChange,
      handlePrevCilickChange1,
      handleNextCilickChange2,
      gangkouue,
     detall_2,

      gklist,
      gknum,
      handleCurrentChanges,
      handleSizeChanges,
      handlePrevCilickChanges,
      handleNextCilickChanges,
      srgkk,
    close1,
      sousuo1,
      czu1,
      handleDeleteel,
      refreshAddress,
       refreshAddress1,
      addnewgk,
      addgk,
      addressVisibleFlag1
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/addressList.scss";
.el-button {
  min-height: 0px;
}

.addcit {
  height: 24px;
  line-height: 24px;
  border-radius: 5px;
  color: #101010;
  font-size: 12px;
  text-align: center;
  background: white;
  padding: 0px 10px;
  cursor: pointer;
}

.sld_address_list {
  width: 1007px;
  float: left;
  position: relative;
}
.fytou {
 position: absolute;
 bottom: 20px;
 right: 0;
}
.teblek {
  margin-top: 8px;
}
.adsele {
  //   height: 47px;
  background-color: rgba(247, 2, 2, 77);
  padding: 11px 10px;
  background-color: rgba(247, 2, 2, 77);
  margin-top: 21px;
  display: flex;
  .detil {
    margin-left: 15px;
    cursor: pointer;
  }
  div {
    // height: 24px;
    line-height: 24px;
    border-radius: 5px;
    color: rgba(16, 16, 16, 100);
    font-size: 12px;
    text-align: center;
    background: white;
    padding: 0px 10px;
  }
}
.tablexx_button {
  display: flex;
  margin-top: 7px;
  div {
    width: 58px;
    height: 27px;
    line-height: 27px;
    border-radius: 5px;
    font-size: 12px;
    text-align: center;
  }
  .sousuo {
    background-color: rgba(247, 2, 2, 77);
    color: rgba(255, 255, 255, 100);
    margin-right: 3px;
    cursor: pointer;
  }
  .czu {
    background-color: rgba(255, 255, 255, 100);
    color: rgba(0, 0, 0, 1);
    border: 1px solid rgba(187, 187, 187, 100);
    cursor: pointer;
  }
}
.tablexx {
  margin-top: 18px;
}
.tablexx_nr {
  display: flex;
  justify-content: space-between;
}
.tablexx_sr {
  span {
    color: rgba(16, 16, 16, 100);
    font-size: 12px;
  }
  .el-input {
    width: 170px;
    height: 29px;
    border-radius: 5px;
    margin-left: 16px;
  }
  .phone {
    margin-left: 33px;
  }
}
.selegg {
  margin-top: 8px;
  display: flex;
  border-bottom: 1px solid rgba(187, 187, 187, 100);
}
.selegg_on {
  width: 150px;
  height: 24px;
  line-height: 24px;
  border-radius: 5px 5px 0px 0px;
  background-color: rgba(229, 229, 229, 100);
  color: rgba(16, 16, 16, 100);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(187, 187, 187, 100);
  cursor: pointer;
}
.selegg_xz {
  color: rgba(247, 2, 2, 77);
  background-color: white;
}


.el-table_2_column_12  {

  text-align: right;
}
.el-table_2_column_11  {
   width: 300px;
}
</style>
<style >
     
</style>